<template>
  <div>

    <div class="grid">
      <div class="grid-title">
        <h4>{{ $t("LIST_ACTION_PROCESS") }}</h4>
        <v-btn class="btn-border-circle" icon color="primary" @click="reloadApi()" :title="$t('RELOAD')">
            <i class="icon-refresh fs-16"></i>
          </v-btn>
      </div>
      <div class="grid-body border-top-unset list-booking-group">
        <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
        <v-data-table :headers="dessertHeaders" :items="processing" :single-expand="false" hide-default-footer
          :no-data-text="$t('NO_RECORDS')" :items-per-page="processing.length" :expanded.sync="expanded" item-key="id"
          show-expand class="elevation-1 pt-3">
          <template v-slot:item.stt="{ item, index }">
            {{ (index + 1) }}
          </template>
          <template v-slot:item.status="{ item, index }">
            <span
              :class="item.status === 'STATUS_PROCESSING' ? 'text-warning' : item.status === 'STATUS_DONE' ? 'text-success' : 'text-danger'">
              {{ $t(item.status) }}
            </span>
          </template>
          <template v-slot:item.action="{ item, index }">
            {{ $t(item.action) }}
          </template>
          <template v-slot:item.updateDate="{ item, value, index }">
            <template>
              {{ utcConvertToLocalTimeZone(item.updateDate) }}
            </template>
          </template>
          <template v-slot:item.doneDate="{ item, value, index }">
            <template>
              {{ item.doneDate ? utcConvertToLocalTimeZone(item.doneDate) : null }}
            </template>
          </template>
          <template v-slot:item.updateDateFinal="{ item, value, index }">
            <template>
              {{ utcConvertToLocalTimeZone(item.updateDateFinal) }}
            </template>
          </template>
          <template v-slot:item.btn="{ item, value, index }">
            <template>
              <div class="d-flex justify-content-end">
                <v-btn x-small text color="primary" dark @click="openPopupDetail(item)">
                  {{ $t('DETAIL') }}
                </v-btn>
                <v-btn x-small color="success" class="ml-2" dark @click="resend(item)"
                  v-if="item.status !== 'STATUS_PROCESSING' && item.status !== 'STATUS_DONE' && isReupdate">
                  {{ $t('RESEND') }}
                </v-btn>
                <v-btn v-if="item.status !== 'STATUS_DONE' && isIgnore" x-small
                  color="red" dark class="ml-2" @click="$refs.deleteDialogComponent.open(item)">
                  {{ $t('IGNORE') }}
                </v-btn>
              </div>
            </template>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <template>
                <v-data-table :headers="headerSub" :items="item.childs" class="elevation-sub" hide-default-footer
                  :items-per-page="item.childs.length" fixed-header max-height="calc(100vh - 369px)">
                  <template v-slot:item.stt="{ item, index }">
                    {{ (index + 1) }}
                  </template>
                  <template v-slot:item.status="{ item, index }">
                    <span
                      :class="item.status === 'STATUS_PROCESSING' ? 'text-warning' : item.status === 'STATUS_DONE' ? 'text-success' : 'text-danger'">
                      {{ $t(item.status) }}
                    </span>
                  </template>
                  <template v-slot:item.errorKey="{ item, index }">
                    {{ $t(item.errorKey) }}
                  </template>
                  <template v-slot:item.updateDate="{ item, value, index }">
                    <template>
                      {{ utcConvertToLocalTimeZone(item.updateDate) }}
                    </template>
                  </template>
                  <template v-slot:item.doneDate="{ item, value, index }">
                    <template>
                      {{ utcConvertToLocalTimeZone(item.doneDate) }}
                    </template>
                  </template>
                  <template v-slot:item.updateDateFinal="{ item, value, index }">
                    <template>
                      {{ utcConvertToLocalTimeZone(item.updateDateFinal) }}
                    </template>
                  </template>
                  <template v-slot:item.object="{ item, value, index }">
                    <template>
                      <v-btn x-small text color="primary" dark @click="openPopupDetail(item)">
                        {{ $t('DETAIL') }}
                      </v-btn>
                    </template>
                  </template>
                  <template v-slot:no-data>
                      <div class="text-center">{{ $t('$vuetify.noDataText') }}</div>
                  </template>
                </v-data-table>
              </template>
            </td>
          </template>
        </v-data-table>
        <div class="p-3 d-flex align-items-center justify-content-end">
          <span class="pt-3">{{ $t("TOTAL") }}: {{ $tc("PROCESS_CAP", processing.length)
          }}</span>
        </div>
      </div>
    </div>
    <v-dialog v-model="detailDialog" max-width="600" content-class="dialog-detail">
      <v-toolbar class="toolbar-update" dense>
        <v-toolbar-title class="text-primary fs-15">
          <strong>{{ $t('DETAIL') }}</strong>
        </v-toolbar-title>
      </v-toolbar>
      <div class="content-update">
        <div class="overflow-auto" style="max-height: 500px">
          <label class="label-title">Request body: </label>
          <div class="ml-3" v-if="objectDescription && objectDescription.object">
            <pre>{{ objectDescription.object }}</pre>
          </div>
          <v-divider />
          <label class="label-title">Process tracking ID: </label>
          <div class="ml-3" v-if="objectDescription && objectDescription.processTrackingId">
            <pre>{{ objectDescription.processTrackingId }}</pre>
          </div>
          <v-divider />
          <label class="label-title">Process tracking ID final: </label>
          <div class="ml-3" v-if="objectDescription && objectDescription.processTrackingIdFinal">
            <pre>{{ objectDescription.processTrackingIdFinal }}</pre>
          </div>
          <v-divider />
          <label class="label-title">ID: </label>
          <div class="ml-3" v-if="objectDescription && objectDescription.id">
            <pre>{{ objectDescription.id }}</pre>
          </div>
        </div>

        <div class="mt-3 d-flex justify-content-end">
          <div class="">
            <v-btn class="" block color="primary" @click="detailDialog = false">
              {{ $t("CLOSE") }}
            </v-btn>
          </div>
        </div>
      </div>
    </v-dialog>
    <confirm-dialog @deleteItem="confirmIgnore" :maxWidth="325" ref="deleteDialogComponent">
      <span slot="title">
        {{ $t("CONFIRM_IGNORE") }}
      </span>
    </confirm-dialog>
  </div>
</template>

<script>

import { service } from "@/_services/Dashboard/dashboard.service.js";
import { _alert, _formatCurrency, _formatDateTimeUTCToLocal } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import moment from "moment";
import { chainService } from "@/_services/ChainManage/chain.service.js";

export default {
  components: {
    "confirm-dialog": () => import('@/components/Utils/ConfirmDialog.vue'),
  },
  data() {
    return {
      expanded: [],
      systemLang: this.$i18n.locale,
      isLoading: true,
      dataTable: [],
      processing: [],
      objectDescription: '',
      detailDialog: false,
      timerId: null,
      isIgnore: false,
      isReupdate: false
    };
  },
  computed: {
    dessertHeaders() {
      return [
        {
          text: this.$t("STT"),
          align: 'start',
          sortable: false,
          value: 'stt',
        },
        {
          text: this.$t("ACTION"),
          value: "action",
        },
        {
          text: this.$t("STATUS"),
          value: "status",
          align: 'start',
        },
        {
          text: this.$t("ACTION_TIME"),
          value: "updateDate",
          align: 'end',
        },
        {
          text: this.$t("UPDATE_TIME"),
          value: "updateDateFinal",
          align: 'end',
        },
        {
          text: this.$t("PROCESS_TIME"),
          value: "doneDate",
          align: 'end',
        },
        {
          text: this.$t("_ACTIVITY.USER_NAME"),
          value: "user",
        },
        {
          text: this.$t("ACCOUNT_UPDATE"),
          value: "userFinal",
        },
        {
          text: "",
          value: "btn",
          align: 'end',
          sortable: false,
        },
        { text: '', value: 'data-table-expand' },
      ]
    },
    headerSub() {
      return [
        {
          text: this.$t("STT"),
          align: 'start',
          sortable: false,
          value: 'stt',
        },
        {
          text: this.$t("STATUS"),
          value: "status",
          align: 'start',
        },

        {
          text: this.$t("ROOM_TYPE"),
          value: "room",
        },
        {
          text: this.$t("SALE_PACKAGE"),
          value: "plan",
        },

        {
          text: this.$t("SALE_CHANNEL"),
          value: "ota",
        },
        {
          text: this.$t("_BOOKING_DETAIL.BOOKING_DETAIL.NOTE"),
          value: "errorKey",
        },
        {
          text: this.$t("ACTION_TIME"),
          value: "updateDate",
          align: 'end',
        },
        {
          text: this.$t("UPDATE_TIME"),
          value: "updateDateFinal",
          align: 'end',
        },
        {
          text: this.$t("PROCESS_TIME"),
          value: "doneDate",
          align: 'end',
        },
        {
          text: "",
          value: "object",
          sortable: false,
          align: 'end',
        },
      ];
    }
  },
  created() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    const userRole = currentUser.user.roles
      ? currentUser.user.roles.map(role => role.fnCode)
      : undefined;
    this.isReupdate = userRole.indexOf("HOTEL_DASHBOARD_REUPDATE_TASK") >= 0
    this.isIgnore = userRole.indexOf("HOTEL_DASHBOARD_IGNORE_TASK") >= 0
    this.initialize();
  },
  methods: {
    reloadApi() {
      this.getProcessing()
    },
    _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return _formatDateTimeUTCToLocal(value, inputFormat, outputFormat);
    },
    // Run when start
    async initialize() {
      this.getProcessing()
      await chainService.getListLangs().then(res => {
        this.languages = res.data;        
        if(this.languages.length > 0) localStorage.setItem('listLangs', JSON.stringify(this.languages));
      });
    },
    getProcessing() {
      this.isLoading = true;
      service.getProcess().then(res => {
        if (res.responseCode === 0) {
          this.processing = res.data;
          this.$forceUpdate();
        } else {
          _alert(res, this.$t(res.data), false);
        }
        this.isLoading = false;
      });
    },
    resend(item) {
      service.updateProcess(item.id).then(res => {
        if (res.responseCode === 0) {
          this.getProcessing();
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    confirmIgnore(item) {
      this.ignore(item);
    },
    ignore(item) {
      service.updateIgrone(item.id).then(res => {
        if (res.responseCode === 0) {
          this.getProcessing();
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    openPopupDetail(item) {
      this.objectDescription = item;
      this.detailDialog = true;
    },
    calcTotalAmount(bookingLines, currencyCode) {
      let amount = 0;
      bookingLines.forEach(x => {
        amount = amount + x.amountPax;
      });
      return _formatCurrency(amount, currencyCode);
    },
    _moment: moment
  },
  destroyed() {
    // clearInterval(this.timerId);
  },
};
</script>